import * as React from 'react';
import {
  PageSection,
} from '@patternfly/react-core';

const EmptyPage: React.FunctionComponent = () => {
  return (
    <PageSection
      style={{
        backgroundColor: '#ffffff',
        minHeight: 'calc(100vh - 200px)',
        width: '100%',
      }}
    >
      {/* Empty page content */}
    </PageSection>
  );
};

export { EmptyPage };

